import { Box, Button } from '@mui/material';

import Presets from './Presets';

import type { LocatedDateRangerPickerValue } from './index';
import type { PickersActionBarProps } from '@mui/x-date-pickers-pro';

type ActionBarProps = PickersActionBarProps & {
  internalValue: LocatedDateRangerPickerValue;
  onChange: (value: LocatedDateRangerPickerValue) => void;
  setInternalValue: (value: LocatedDateRangerPickerValue) => void;
};

const ActionBar = ({
  className,
  internalValue,
  onAccept,
  onCancel,
  onChange,
  setInternalValue,
}: ActionBarProps) => (
  <Box
    alignItems="center"
    className={className}
    display="flex"
    justifyContent="space-between"
    padding={2}
    sx={({ palette }) => ({
      borderTop: `1px solid ${palette.divider}`,
    })}
  >
    <Presets
      onChange={([start, end]) => {
        setInternalValue({ end, start });
      }}
      value={internalValue}
    />

    <div>
      <Button onClick={onCancel} size="small" variant="outlined">
        Cancel
      </Button>

      <Button
        disabled={!internalValue.start || !internalValue.end}
        onClick={() => {
          if (internalValue.start && internalValue.end) {
            // If the user chooses from the calendar, calling onAccept here will trigger onAccept of
            // DateRangePicker component. But if the user chooses from preset, onAccept of the
            // DateRangePicker is not called. As a result, we resort to calling onChange manually to
            // satisfy both cases, and disallow passing onAccept as a prop in the DateRangePicker
            // component.

            onChange(internalValue);
            onAccept();
          }
        }}
        size="small"
        sx={{ marginLeft: 1 }}
      >
        Apply
      </Button>
    </div>
  </Box>
);

export default ActionBar;
